import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Header } from 'components';
import {
  Container,
  Colors,
  Modal,
  PrimaryButton,
  device,
  H1,
} from 'utils';
import {
  AcceptEdit,
  RejectEdit,
  HoldenEdit,
  UpdatesForm,
  // Success,
  TimeLineTab,
  DonationsTable,
  SuccessfulPop,
  FinishedPop,
} from './components';
import { RewardsTable } from './components/RewardsTable';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { ProjectsActions } from 'redux/actions';
import ContactUsPage from 'scenes/ContactUsPage/ContactUsPage';
import { Tooltip } from 'antd';
import InputUrlModal from 'scenes/InputUrlModal/InputUrlModal';
import brandRoles from 'utils/brandRoles';
import { FONT, Tag, TextButton, LineIcon } from './components/ui';

// Status-Etikett im Kopfbereich
const STATUS_TAGS = {
  accepted: ['Online', 'gruen'],
  edit_pending: ['Online', 'gruen'],
  edit_accepted: ['Online', 'gruen'],
  edit_declined: ['Online', 'gruen'],
  accepted_and_draft: ['Online', 'gruen'],
  successful: ['Erfolgreich beendet', 'gruen'],
  finished: ['Beendet', 'neutral'],
  pending: ['In Prüfung', 'neutral'],
  declined: ['Abgelehnt', 'neutral'],
  totally_declined: ['Abgelehnt', 'neutral'],
};

const MyProjectDetailsWrapper = styled.section`
  display: flex;
  justify-content: space-between;

  .my-project-details__content {
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    max-width: 1000px;
    margin: 0 auto;
    padding: 40px 24px 64px;
    font-family: ${FONT};

    @media ${device.allMobile} {
      padding: 24px 16px 48px;
    }
  }
`;

const PageHead = styled.header`
  .back {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 500;
    color: ${brandRoles.neutral700};

    &:hover {
      color: ${brandRoles.neutral800};
    }
  }

  .title-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
    margin-top: 12px;
  }

  h1 {
    margin: 0;
    font-family: ${FONT};
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: ${brandRoles.neutral800};

    @media ${device.allMobile} {
      font-size: 24px;
    }
  }
`;

const ActionBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  padding-bottom: 8px;

  .buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .buttons button {
    margin-bottom: 0;
  }

  .links {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 20px;
  }

  @media ${device.allMobile} {
    .buttons,
    .buttons > a,
    .buttons > span {
      width: 100%;
    }

    .buttons button {
      width: 100%;
    }
  }
`;

const ModalTitle = styled.div`
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #181d27;
`;

const MyProjectDetailsModal = styled.div`
  .modal__content {
    min-width: 550px;
  }
  .modal__body {
    padding: 20px;
  }
  @media ${device.allMobile} {
    .modal__content {
      min-width: auto !important;
    }
  }
`;
const GotoDiskTop = styled.div`
  display: none;
  @media ${device.allMobile} {
    display: block;
    margin: 150px 20px;
    text-align: center;
    border: 1px solid ${Colors.grey};
    border-radius: 15px;
    padding: 20px 10px;
    color: ${Colors.white};
    background: ${Colors.secondaryColor};
    h1 {
      color: ${Colors.white};
      font-weight: bold;
    }
  }
`;
class YourProjectDetailsPage extends Component {
  componentDidMount() {
    const {
      match: {
        params: { id },
      },
      getProjectUpdates,
      getProjectStatus,
    } = this.props;
    getProjectStatus(id, {});

    getProjectUpdates(id);
  }
  static propTypes = {
    updates: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    getProjectUpdates: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    getProjectStatus: PropTypes.func.isRequired,
    projectStatus: PropTypes.object.isRequired,
    removeEdit: PropTypes.func.isRequired,
    duplicateDraft: PropTypes.func.isRequired,
  };
  state = {
    showModal: false,
    showMore: true,
    perPage: 5,
    showContact: false,
    inputUrl: false,
  };
  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };
  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };
  handleInputModal = () => {
    this.setState({ inputUrl: true });
  }

  handleDuplicateProject = (url) => {
    const {
      match: {
        params: {id},
      },
      duplicateDraft,
    } = this.props;
    duplicateDraft(id, url);
  }

  render() {
    const { showModal, showContact, inputUrl } = this.state;
    const {
      match: {
        params: { id },
      },
      updates,
      projectStatus,
      removeEdit,
      user,
    } = this.props;

    const handleStatus = (status) => {
      switch (status) {
        case 'accepted':
        case 'edit_pending':
        case 'edit_accepted':
        case 'edit_declined':
        case 'accepted_and_draft':
          return 'Online';
        case 'declined':
        case 'pending':
        case 'totally_declined':
        case 'successful':
        case 'finished':
          return 'Offline';
        default:
          return 'Offline';
      }
    };
    const canPostUpdate =
      handleStatus(projectStatus.status) === 'Online' ||
      projectStatus.status === 'successful' ||
      projectStatus.status === 'finished';
    const canEdit =
      projectStatus.status !== 'totally_declined' &&
      projectStatus.status !== 'edit_declined' &&
      projectStatus.status !== 'successful' &&
      projectStatus.status !== 'finished';
    const statusTag = STATUS_TAGS[projectStatus.status];

    return (
      <>
        <div>
          <Header relativeHeader={true} />
          <MyProjectDetailsWrapper>
            <Container className="my-project-details__content">
              <>
                <PageHead>
                  <Link to="/profile#started-projects" className="back">
                    <LineIcon name="zurueck" size={16} />
                    Eigene Projekte
                  </Link>
                  <div className="title-row">
                    <h1>{projectStatus.title || 'Dein Projekt'}</h1>
                    {statusTag && <Tag $tone={statusTag[1]}>{statusTag[0]}</Tag>}
                  </div>
                </PageHead>
                {projectStatus.status === 'finished' && <FinishedPop />}
                {projectStatus.status === 'successful' && <SuccessfulPop />}
                {projectStatus.status === 'edit_accepted' && (
                  <AcceptEdit
                    time={projectStatus.submit_date}
                    projectId={id}
                    removeEdit={removeEdit}
                  />
                )}
                {projectStatus.status === 'edit_declined' && (
                  <RejectEdit
                    message={projectStatus.message}
                    time={projectStatus.submit_date}
                    projectId={id}
                    removeEdit={removeEdit}
                  />
                )}
                {(projectStatus.status === 'edit_pending' ||
                  projectStatus.status === 'pending') && (
                  <HoldenEdit time={projectStatus.submit_date} />
                )}

                <ActionBar>
                  <div className="links">
                    <TextButton type="button" onClick={this.handleInputModal}>
                      Projekt duplizieren
                    </TextButton>
                    <TextButton
                      type="button"
                      onClick={() => this.setState({ showContact: true })}
                    >
                      Support anfragen
                    </TextButton>
                  </div>
                  <div className="buttons">
                    {canEdit &&
                      (projectStatus.status === 'declined' ? (
                        <Tooltip
                          title="Dein Projekt wurde abgelehnt."
                          placement="bottom"
                          color="#000"
                          overlayInnerStyle={{
                            color: '#fff',
                            borderRadius: '8px',
                          }}
                          arrow={true}
                        >
                          <span>
                            <PrimaryButton primary={true} disabled={true}>
                              Projekt bearbeiten
                            </PrimaryButton>
                          </span>
                        </Tooltip>
                      ) : (
                        <Link to={`/start-project/${id}`}>
                          <PrimaryButton primary={true}>
                            Projekt bearbeiten
                          </PrimaryButton>
                        </Link>
                      ))}
                    {canPostUpdate && projectStatus.url && (
                      <Link to={`/project/${projectStatus.url}`}>
                        <PrimaryButton primary={true}>
                          Projektseite ansehen
                        </PrimaryButton>
                      </Link>
                    )}
                    {canPostUpdate && (
                      <PrimaryButton
                        primary={false}
                        onClick={() => this.handelShowModal()}
                      >
                        Neues Update
                      </PrimaryButton>
                    )}
                  </div>
                </ActionBar>
                <div>
                  {showContact && (
                    <Modal
                      width="830px"
                      title={
                        <div style={{ padding: 20 }}>
                          Kontaktiere uns, wir helfen gerne.
                        </div>
                      }
                      showModal={showContact}
                      handelCloseModal={() =>
                        this.setState({ showContact: false })
                      }
                    >
                      <ContactUsPage
                        user={user}
                        projectId={id}
                        formOnly
                        closeModal={() => this.setState({ showContact: false })}
                      />
                    </Modal>
                  )}
                  {inputUrl && (
                    <Modal
                      width="830px"
                      title={
                        <div style={{ padding: 20 }}>
                          Bitte gib eine neue URL ein.
                        </div>
                      }
                      showModal={inputUrl}
                      handelCloseModal={() =>
                        this.setState({ inputUrl: false })
                      }
                    >
                      <InputUrlModal
                        projectId={id}
                        handleDuplicateProject={this.handleDuplicateProject}
                      />
                    </Modal>
                  )}
                </div>
                {canPostUpdate && <DonationsTable projectId={id} />}

                {/* Rewards */}
                {canPostUpdate && <RewardsTable projectId={id} />}

                {updates && updates.length > 0 && (
                  <TimeLineTab updates={updates} projectId={id} />
                )}
              </>
            </Container>
          </MyProjectDetailsWrapper>
        </div>
        <MyProjectDetailsModal>
          <Modal
            width={'640px'}
            showModal={showModal}
            handelCloseModal={this.handelCloseModal}
            noLogo
            leftMargin={10}
            leftTitle={<ModalTitle>Neues Update</ModalTitle>}
          >
            <UpdatesForm
              projectId={id}
              handelCloseModal={this.handelCloseModal}
            />
          </Modal>
        </MyProjectDetailsModal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { updates, loading, errors, projectStatus } = state.projects;
  return {
    updates,
    loading,
    errors,
    projectStatus,
    user: state.authentication.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getProjectUpdates: (projectId) =>
    dispatch(ProjectsActions.getProjectUpdates(projectId)),
  getProjectStatus: (projectId) =>
    dispatch(ProjectsActions.getProjectStatus(projectId)),
  removeEdit: (projectId) => dispatch(ProjectsActions.removeEdit(projectId)),
  duplicateDraft: (projectId, url) => dispatch(ProjectsActions.duplicateDraft(projectId, url)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(YourProjectDetailsPage);
